<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6fVl3D/tc-custom/9781936070725.jpg?1737164547392" alt="This image is the cover for the book Black Music, Akashi Classics: Renegade Reprint Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Music, Akashi Classics: Renegade Reprint Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The essential collection of jazz writing by the celebrated poet and author of <i>Blues People</i>—reissued with a new introduction by the author.</b><br/>  <br/> In the 1960s, LeRoi Jones—who would later be known as Amiri Baraka—was a pioneering jazz critic, articulating in real time the incredible transformations of the form taking place in the clubs and coffee houses of New York City. In <i>Black Music, he sheds light on </i>the brilliant young jazz musicians of the day: John Coltrane, Thelonious Monk, Miles Davis, Ornette Coleman, Cecil Taylor, Archie Shepp, Sun Ra, and others.<br/>  <br/> Combining firsthand immediacy with wide-ranging erudition, <i>Black Music</i> articulates the complexities of modern jazz while also sharing insights on the nature of jazz criticism, the creative process, and the development of a new way forward for black artists. This rich and vital collection is comprised of essays, reviews, interviews, liner notes, musical analyses, and personal impressions from 1959–1967.<br/>  <br/> “In <i>Black Music</i>, Baraka wrote with ecstasy—highly informed and intricate—about ecstatically complex music.”—Richard Brody, <i>The New Yorker</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        LeRoi Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c5270fa